import React from "react"
import { BoxWrapper } from "components"

const About = ({ boxWrapperProps }: IAboutContainerProps) => {
  return <BoxWrapper {...boxWrapperProps}></BoxWrapper>
}

export default About
